<template>
  <div>
    <project-table
      ref="projectTable"
      :extraQuery="extraQuery"
      :operateColumns="operateColumns"
      :extraSearch="extraSearch"
    ></project-table>
    <!-- 审核文件列表 -->
    <Modal
      v-model="auditFileVisible"
      title="审核文件"
      width="800"
    >
      <div class="fileList">
        <Spin
          fix
          v-if="loadingFile"
        >文件加载中..</Spin>
        <Collapse accordion>
          <Panel
            v-for="fileType in allFiles"
            :key="fileType.fileTypeId"
          >
            <div style="display:inline-block;width:90%">
              <Button
                style="margin:0 10px"
                type="success"
                size="small"
              >{{fileType.dbfile.length}}</Button>
              <span>{{fileType.fileTypeName}}</span>
            </div>
            <div slot="content">
              <Table
                :columns="fileColumns"
                :data="fileType.dbfile"
              ></Table>
            </div>
          </Panel>
        </Collapse>
      </div>
      <div slot="footer">

      </div>
    </Modal>
    <!-- 审核 -->
    <Modal
      title="项目审核"
      v-model="examineVisible"
    >
      <div class="responsibility">
        <div class="title">责任状</div>
        <div class="content">
          经核实，在<span style="letter-spacing: 0">{{projectData.projectFull}}</span> {{projectData.projectName}}
          的工作中，各责任人均严格依据相关法律法规及采联国际招标采购集团有限公司
          各项规定控制项目质量，履行岗位职责。审核人员对项目文件上传情况和上传文件质量负责，并按检查标准对项目各
          阶段的文件是否符合要求进行了核实、确认。各责任人对项目文件的真实性、有效性、完整性、合法性、合理性及规范性负责。
        </div>
        <div class="content">
          如因各责任人疏忽麻痹，未尽上述应尽职责，按违反公司制度、规定作相关处理。
        </div>
        <div class="people">
          责任人：
            <div>
              <div>{{getFirstManager(projectData.area)}}</div>
              <div>{{projectData.am}}</div>
              <div>{{$store.state.session.user.name}}</div>
              <div>{{formatDate()}}</div>
            </div>  
        </div>
      </div>
      <div>
        <span>若审核不通过，请输入不通过原因</span>
        <Input
          style="margin:5px 0;"
          v-model="rejectReason"
        ></Input>
      </div>
      <div slot="footer">
        <Button
          type="success"
          @click="passProject"
        >通过</Button>
        <Button
          type="error"
          @click="rejectProject"
        >不通过</Button>
        <Button @click="examineVisible=false">取消</Button>
      </div>
    </Modal>
    <!-- 复核 -->
    <Modal
      title="复核"
      v-model="reviewlVisible"
    >
      <div>
        <Form ref="formRef" :model="formValidate" :rules="ruleValidate">
          <Form-item label="复核方式:" prop="reviewWay" style="width: 60%">
              <Select v-model="formValidate.reviewWay" placeholder="请选择复核方式">
                  <Option value="1">形式审核</Option>
                  <Option value="2">实质审核</Option>
              </Select>
          </Form-item>
        </Form>
      </div>
      <div>
        <span>若复核不通过，请输入不通过原因</span>
        <Input
          style="margin:5px 0;"
          v-model="rejectReason"
        ></Input>
      </div>
      <div slot="footer">
        <Button
          type="success"
          @click="endProject"
        >通过</Button>
        <Button
          type="error"
          @click="rejectProject"
        >不通过</Button>
        <Button @click="examineVisible=false">取消</Button>
      </div>
    </Modal>
    <Modal
      title="结项详情"
      v-model="detailVisible"
    >
      <div class="examine-wrapper">
        <template v-if="examineDetails.length > 0">
          <div
            class="examine-item"
            v-for="(examine, index) in examineList"
            :key="index"
          >
            <span style="margin-right:10px;"><span style="font-weight:bold">申请时间：</span>{{examine.applyTime}}</span>
            <span style="margin-right:10px;"><span style="font-weight:bold;">操作时间：</span>{{examine.rejectTime}}</span>
            <div>
              <span style="margin-right:10px;"><span style="font-weight:bold;margin-right:10px;">操作人：</span>{{examine.rejectPerson}}</span>
              <span style="margin-right:10px;" v-if="examine.status"><span style="font-weight:bold">状态：</span>{{examine.status}}</span>
            </div>
            <div style="margin:5px 0 15px 0;">
              <span style="font-weight:bold">备注：</span>{{examine.rejectReason}}
            </div>
          </div>
        </template>
        <template v-else>
          <div class="examine-item">
            <span style="margin-right:10px;"><span style="font-weight:bold">申请时间：</span>{{projectData.appStartTime | filterTime}}</span>
            <span style="margin-right:10px;" v-if="projectData.appPassTime"><span style="font-weight:bold">操作时间：</span>{{projectData.appPassTime | filterTime}}</span>
            <span style="font-weight:bold">状态：</span>{{projectData.endStatusName}}
            <!-- <div style="margin:5px 0 15px 0;">
              <span style="font-weight:bold">状态：</span>{{projectData.endStatusName}}
            </div> -->
          </div>
        </template>
      </div>
      <div slot="footer"></div>
    </Modal>
    <!-- 财务一览 -->
    <Modal
      class="finanicalflow-modal"
      v-model="financialVisible"
      title="财务一览"
      width="1350"
      :scrollable="true"
    >
      <financial-flows :projectData="projectData" :agreement="agreement"></financial-flows>
      <div slot="footer">
        <Button @click="financialVisible=false">取消</Button>
      </div>
    </Modal>
  </div>
</template>

<script>
import ProjectTable from '@/components/projectTable'
import axios from 'axios'
import ajax from '@/lib/ajax'
import requestUrls from '@/lib/requestUrls'
import x2js from "x2js"
import Util from '@/lib/util'
import PageRequest from '@/store/entities/page-request'
import { formatDate } from '@/lib/tool'
import {FieldType,Filter,CompareType} from '@/store/entities/filter'
import localFile from '@/lib/localFile'
import sendMessage from '@/lib/message'
import FinancialFlows from '../projectFlow/financialFlows'//财务流

export default {
  name: 'MendProjectAudit',
  components: {
    ProjectTable,
    FinancialFlows
  },
  data() {
    return {
      formValidate: {
        reviewWay: ''
      },
      ruleValidate: {
        reviewWay: [{ required: true, message: '请选择复核方式', trigger: 'blur' }],
      },
      projectData: {},
      operateColumns: [
        {
          title: '审核状态',
          width: 160,
          align: 'center',
          render: (h, params) => {
            if (!params.row.endStatusCode) {
              return h('div', '未发起')
            } else {
              switch(params.row.endStatusCode) {
               /*  case '1': return h('div', '结项申请')
                case '2': return h('div', '待复核')
                case '3': return h('div', `初审不通过`)
                case '4': return h('div', '形式审核通过')
                case '5': return h('div', '实质审核通过')
                case '6': return h('div', '形式审核不通过')
                case '7': return h('div', '实质审核不通过') */
                case '1': return h('div', '结项申请')
                case '2': return h('div', '审核通过')
                case '3': return h('div', `审核不通过`)
                case '4': return h('div', '形式审核通过')
                case '5': return h('div', '实质审核通过')
                case '6': return h('div', '形式审核不通过')
                case '7': return h('div', '实质审核不通过')
              }
            }
          }
        },
        {
          title: '申请时间',
          width: 100,
          render: (h, params) => {
            let time = new Date(params.row.appStartTime).toLocaleDateString()
            return h('div', time)
          }
        },
        {
          title: '操作',
          align: 'center',
          width: 350,
          render: (h, params) => {
            return h('div', {
              style: {
                textAlign: 'center'
              }
            }, [
                h('Button', {
                  props: {
                    type: 'primary',
                    size: 'small',
                  },
                  style: {
                    marginRight: '5px'
                  },
                  on: {
                    click: () => {
                      this.projectData = params.row
                      this.auditFileVisible = true
                      this.getFileAndTypes()
                      this.getReviewFile()
                    }
                  }
                }, '审核文件'),
                h('Button', {
                  props: {
                    type: 'primary',
                    size: 'small',
                    disabled: params.row.endStatusCode !== '1' || !this.isHasRole()
                  },
                  style: {
                    marginRight: '5px'
                  },
                  on: {
                    click: () => {
                      this.projectData = params.row
                      console.log(this.projectData);
                      this.rejectReason = ''
                      this.examineVisible = true
                    }
                  }
                }, '项目审核'),
                h('Button', {
                  props: {
                    type: 'primary',
                    size: 'small'
                  },
                  style: {
                    marginRight: '5px'
                  },
                  on: {
                    click: () => {
                      this.projectData = params.row
                      this.financialVisible = true
                      ajax.get(requestUrls.CLTrustAgreementInfo.GetPaged, {
                        params: {
                          filter: `projectId == ${params.row.id}`
                        }
                      }).then(res => {
                        this.agreement = res.data.result.items
                      })
                    }
                  }
                }, '财务一览'),
                h('Button', {
                  props: {
                    type: 'primary',
                    size: 'small',
                    disabled: params.row.endStatusCode !== '2'
                  },
                  style: {
                    marginRight: '5px',
                    display: this.showReview(this.$store.state.session.user.name) ? 'inline-block': 'none'  
                  },
                  on: {
                    click: () => {
                      this.$Message.info('不需要复核项目')
                      /* this.projectData = params.row
                      console.log('params.row', this.$store.state.session.user.name)
                      this.rejectReason = ''
                      if(this.projectData.endStatusCode === '2') {
                        this.reviewlVisible = true
                        this.formValidate.reviewWay = ''
                      } */
                    }
                  }
                }, '复核'),
                h('Button', {
                  props: {
                    type: 'primary',
                    size: 'small',
                  },
                  on: {
                    click: () => {
                      this.projectData = params.row
                      const x2Json = new x2js()
                      this.examineDetails = []
                      if (this.projectData.endStatusName.indexOf('<recordList>') !== -1) {
                        this.examineDetails = x2Json.xml2js(this.projectData.endStatusName).recordList.record
                      }
                      this.detailVisible = true
                    }
                  }
                }, '详情'),
              ])
          }
        }
      ],
      fileColumns: [
        {
          title: '文件名称',
          key: 'fileName'
        },
        {
          title: '文件类别',
          key: 'fileTypeName',
          width: 100
        },
        {
          title: '操作',
          width: 100,
          render: (h, params) => {
            return h('div', [
              h('Button', {
                props: {
                  type: 'primary',
                  size: 'small'
                },
                style: {
                  marginRight: '5px'
                },
                on: {
                  click: () => {
                    this.viewFile(params.row)
                  }
                }
              }, '预览')
            ])
          }
        },
      ],
      extraQuery: {
        status: ' and (projectState == "已开评标完" or projectState == "项目结项" or projectState == "项目失败")',
        endStatus: '  and endStatusCode > "0"',
        rolePermission: ''
      },
      auditFileVisible: false,
      typesAndFiles: [],
      loadingFile: false,
      fileUrl: '',
      examineVisible: false,
      rejectReason: '',
      fileList: '',
      extraSearch: {
        searchEndTime: true,
        searchManager: true
      },
      // username: '',
      detailVisible: false,
      examineDetails: [],
      financialVisible: false,
      reviewlVisible: false,
      agreement: [],
      filters: [
        {Type:FieldType.String,Value:'',FieldName:'Name',CompareType:CompareType.Contains},
        {Type:FieldType.String,Value:'',FieldName:'DisplayName',CompareType:CompareType.Contains},
        {Type:FieldType.Boolean,Value: true,FieldName:'allowLowEdit',CompareType:CompareType.Equal},
      ]
    }
  },
  async created() {
    const x2Json = new x2js()
  },
  computed: {
    allFiles() {
      return this.fileList.concat(this.typesAndFiles)
    },
    examineList() {
      return this.examineDetails.slice(1)
    },
    username () {
      return this.$store.state.session.user.name
    },
  },
  methods: {
    showReview(name) {
      if(['林嘉炯','何梓豪','李家儿','李晋裕','滕昭荣','颜惠军'].includes(name)) {
        return true
      }
      return false
    },
    // 判断角色列表是否包含结项审核
    isHasRole () {
      return this.$store.getters["session/hasRoles"]("结项审核")
    },
    async getReviewFile() {
      const fl = 67
      // let rep = await axios.post(`http://oa.chinapsp.cn:8088/FileModule/Gdfile/AbpGetFileList?npid=${this.projectData.id}&fl=${fl}`)
      const params = {
        filter: `fileTypeId=="${fl}" and projectId=="${this.projectData.id}"`
      }
      let rep = await ajax.get(requestUrls.clfile.getList, { params })

      let result = []
      rep.data.result.forEach(item => {
        result.push({
          fileGuid: item['fileGuid'],
          fileName: item['fileName'],
          fileSuffix: item['fileSuffix'],
          fileTypeId: item['fileTypeId'],
          fileTypeName: item['fileTypeName'],
          id: item.id,
          projectId: item['projectId'],
          uploadPerson: item['uploadPerson'],
          uploadTime: item['uploadTime']
        })

      })
      this.fileList = [
        {
          fileTypeId: fl,
          dbfile: result,
          fileTypeName: '评审文件'
        }
      ]
    },
    async getFileAndTypes() {
      this.loadingFile = true
      let rep = await ajax.get(requestUrls.ClFileGather.GetFileGather, {
        params: {
          pid: this.projectData.id
        }
      })
      this.loadingFile = false
      if (rep.data.success) {
        this.typesAndFiles = rep.data.result.items
      }
    },
    async viewFile(file) {
      // 文件地址
      // let requestUrl = `http://oa.chinapsp.cn:8088/FileModule/Gdfile/downFile?id=${row.id}&name=${this.username}`
      // 文件类型
      let fileType = file.fileSuffix

      this.loadingFile = true

      // // 获取blob对象地址
      // let rep = await axios.get(requestUrl, { responseType: 'blob' })
      // let blob = new Blob([rep.data])
      // let fileUrl = window.URL.createObjectURL(blob)

      const blobUrl = await localFile.downLoadBlob(file.fileGuid, file.fileName, file.fileSuffix)

      this.loadingFile = false

      // pdf预览
      let pdfTypes = ['.pdf']
      if (pdfTypes.indexOf(fileType) !== -1) {
        window.open('pdf/web/viewer.html?file=' + blobUrl)
        return
      }

      // 图片预览
      let imgTypes = ['.png', '.jpg', '.jpeg']
      if (imgTypes.indexOf(fileType) !== -1) {
        this.$showImage(blobUrl)
        return
      }

      // localFile.currentLoad(blobUrl, file.fileName)
      localFile.directLoadFile(file.fileGuid, file.fileName, file.fileSuffix)

    },
    passProject() {
      this.$Modal.confirm({
        title: '审核通过',
        content: `项目：${this.projectData.projectName} 审核通过`,
        onOk: async () => {
          this.$Spin.show()
          try {
            // let time = new Date().toLocaleDateString()

            let time = formatDate()

            let endStatusName = ''
            const x2Json = new x2js()

            let record = [{}]
            if (this.projectData.endStatusName && this.projectData.endStatusName.indexOf('<recordList>') !== -1) {
              record = x2Json.xml2js(this.projectData.endStatusName).recordList.record
            }

            record.push({
              applyTime: this.projectData.appStartTime.replace('T', ' ').split('.')[0],
              rejectTime: time,
              rejectReason: this.rejectReason,
              rejectPerson: this.$store.state.session.user.name,
              status: '审核通过'
            })

            endStatusName = x2Json.js2xml({ recordList: { record: record } })

            // 更新审核状态
            let rep = await ajax.put(requestUrls.ClProjectDb.UpdateEndStatus, {
              id: this.projectData.id,
              endStatusCode: '2',
              endStatusName: endStatusName,
              appStartTime: this.projectData.appStartTime,
              appPassTime: time,
              appNoPassTime: '',
              FReviewePerson: this.$store.state.session.user.name // 结项初审人员
            })
            this.$Spin.hide()
            if (rep.data.success) {
              if(this.projectData.dataSource == '内网立项'){
                // 若该项目是在3.0立项则审核通过后修改结项状态
                ajax.put(requestUrls.ClProjectDb.UpdateStatus, {
                  id: this.projectData.id,
                  projectState: '项目结项'
                })
              }
              this.$Message.success('审核成功')
              this.examineVisible = false
              // 刷新数据
              this.$refs.projectTable.refreshProject()
            } else {
              this.$Message.error('操作失败')
            }
          } catch (err) {
            this.$Spin.hide()
            this.$Message.error('操作失败')
          }
        }
      })
    },
    endProject() {
      this.$refs['formRef'].validate((valid) => {
          if (valid) {
            this.$Modal.confirm({
              title: '复核通过',
              content: `项目：${this.projectData.projectName} 审核通过`,
              onOk: async () => {
                this.$Spin.show()
                try {
                  // let time = new Date().toLocaleDateString()

                  let time = formatDate()

                  let endStatusName = ''
                  const x2Json = new x2js()

                  let record = [{}]
                  
                  if (this.projectData.endStatusName && this.projectData.endStatusName.indexOf('<recordList>') !== -1) {
                    record = x2Json.xml2js(this.projectData.endStatusName).recordList.record
                  }

                  let endStatusCode = ''
                  let status = ''
                  if(this.formValidate.reviewWay === '1') {
                    endStatusCode = '4'
                    status = '形式审核通过'
                  } else {
                    endStatusCode = '5'
                    status = '实质审核通过'
                  }

                  record.push({
                    applyTime: this.projectData.appStartTime.replace('T', ' ').split('.')[0],
                    rejectTime: time,
                    rejectReason: this.rejectReason,
                    rejectPerson: this.$store.state.session.user.name,
                    status
                  })

                  endStatusName = x2Json.js2xml({ recordList: { record: record } })

                  // 更新审核状态
                  let rep = await ajax.put(requestUrls.ClProjectDb.UpdateEndStatus, {
                    id: this.projectData.id,
                    endStatusCode,
                    endStatusName: endStatusName,
                    appStartTime: this.projectData.appStartTime,
                    appPassTime: time,
                    appNoPassTime: '',
                    SReviewePerson: this.$store.state.session.user.name // 结项复审人员
                  })
                  this.$Spin.hide()
                  if (rep.data.success) {
                    this.$Message.success('复核成功')
                    this.examineVisible = false
                    this.reviewlVisible = false
                    // 刷新数据
                    this.$refs.projectTable.refreshProject()

                    // 修改项目状态
                    ajax.put(requestUrls.ClProjectDb.UpdateStatus, {
                      id: this.projectData.id,
                      projectState: '项目结项'
                    })

                    // 发送微信通知
                    this.sendAuditMessage(record, {
                      auditState: `审核通过-${this.projectData.projectFull}`,
                      description: '结项通过'
                    })

                  } else {
                    this.$Message.error('操作失败')
                  }
                } catch (err) {
                  this.$Spin.hide()
                  this.$Message.error('操作失败')
                }
              }
            })
          }
      })
    },
    rejectProject() {
      if (!this.rejectReason) {
        this.$Message.error('请输入结项不通过原因')
        return
      }
      this.$Modal.confirm({
        title: '结项不通过',
        content: `项目：${this.projectData.projectName} 审核不通过`,
        onOk: async () => {
          this.$Spin.show()
          try {

            let time = formatDate()

            let endStatusName = ''
            const x2Json = new x2js()

            let record = [{}]
            if (this.projectData.endStatusName && this.projectData.endStatusName.indexOf('<recordList>') !== -1) {
              record = x2Json.xml2js(this.projectData.endStatusName).recordList.record
            }

            let endStatusCode = '3'
            let status = '初审不通过'

            if(this.formValidate.reviewWay === '1') {
              endStatusCode = '6'
              status = '形式审核不通过'
            } else if (this.formValidate.reviewWay === '2') {
              endStatusCode = '7'
              status = '实质审核不通过'
            }

            record.push({
              applyTime: this.projectData.appStartTime.replace('T', ' ').split('.')[0],
              rejectTime: time,
              rejectReason: this.rejectReason,
              rejectPerson: this.$store.state.session.user.name,
              status
            })

            endStatusName = x2Json.js2xml({ recordList: { record: record } })

            let rep = await ajax.put(requestUrls.ClProjectDb.UpdateEndStatus, {
              id: this.projectData.id,
              endStatusCode,
              endStatusName: endStatusName,
              appStartTime: this.projectData.appStartTime,
              appPassTime: '',
              appNoPassTime: time
            })
            this.$Spin.hide()
            if (rep.data.success) {
              this.$Message.success('审核成功')
              this.examineVisible = false
              this.reviewlVisible = false
              // 刷新数据
              this.$refs.projectTable.refreshProject()
              // 修改项目状态
              if (this.projectData.projectState === '项目结项') {
                ajax.put(requestUrls.ClProjectDb.UpdateStatus, {
                  id: this.projectData.id,
                  projectState: '已开评标完'
                })
              }

              // 发送微信通知
              this.sendAuditMessage(record, {
                auditState: `审核不通过-${this.projectData.projectFull}`,
                description: this.rejectReason
              })

            } else {
              this.$Message.error('操作失败')
            }
          } catch (err) {
            this.$Spin.hide()
            this.$Message.error('操作失败')
          }
        }
      })
    },
    // 获取申请人发送消息
    sendAuditMessage (record, params) {
      // 获取申请人
      let applyName = ''
      const reverseRecord = record.reverse()
      for (let i = 0; i < reverseRecord.length; i++) {
        const item = reverseRecord[i]
        if (item.status === '结项申请') {
          applyName = item.rejectPerson
          break
        }
      }
      const { auditState, description } = params
      const messageParams = {
        uniqueId: applyName,
        contentJson: {
          title: auditState,
          subTitle: '结项申请',
          url: 'http://qy.chinapsp.cn:8884?qyLogin#/projectCenter/documentSummary',
          description
        }
      }
      sendMessage('wechat', messageParams)
    },
    getFirstManager (area) {
      console.log(area);
      switch (area) {
        case '广东省,广州市': return '陈智健'
        case '广东省,深圳市': return '刘勇'
        case '广东省,佛山市': return '谢天'
        case '广东省,江门市': return '胡茂林'
        case '广东省,肇庆市': return '段凡'
        case '广东省,河源市': return '陈韬'
        case '广东省,汕头市': return '魏燕纯'
        case '广东省,汕尾市': return '郑非'
        case '广东省,惠州市': return '郑非'
        case '广东省,茂名市': return '郑建荣'
        case '广东省,湛江市': return '何日华'
        case '广东省,清远市': return '李迪'
        case '广东省,韶关市': return '罗林杰'
        case '四川省,成都市': return '罗大伟,郎健'
        case '海南省,海口市': return '邹英水'
        case '海南省,三亚市': return '邹英水'
        case '湖北省,武汉市': return '项春'
        case '云南省,昆明市': return '傅强'
        case '北京市,北京市': return '司志宇'
      }
    },
    formatDate
  },
  filters: {
    filterTime(val) {
      if (!val) {
        return ''
      }
      return val.replace('T', ' ').split('.')[0]
    }
  }
}
</script>

<style lang="less" scoped>
.responsibility {
  margin: 0 10px 40px;
  .title {
    text-align: center;
    font-weight: 600;
  }
  .content {
    text-indent: 2em;
    letter-spacing: 2px;
    color: #666;
  }
  .people {
    display: flex;
    justify-content: flex-end;
  }
}
.fileList {
  overflow: auto;
  max-height: 400px !important;
}
/deep/ .ivu-form-item-content {
  display: flex;
}
</style>
